var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-charts-dashboard',{attrs:{"title":_vm.chartDataComputed.title,"options":_vm.chartDataComputed.options,"deep-copy-on-update":_vm.chartDataComputed.deepCopyOnUpdate,"is-loading":_vm.chartDataComputed.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }